import Button from './components/Button';
import { PbRenderElementPlugin } from '@whalecloud/page-builder-core/utils/types';

export default (): PbRenderElementPlugin => ({
  name: 'button',
  pluginComponent: Button,
});
